import { Img } from '@filejet/sdk/react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useSignOut } from '../hooks/useSignOut';
import { useIdentity } from '../identityContext';
import { Divider } from './coreComponents/divider';
import { MenuItem } from './coreComponents/menuItem';
import { StyledMenu } from './coreComponents/styledMenu';
import { UserAvatar } from './coreComponents/userAvatar';

export function AccountMenu() {
  const identity = useIdentity();
  const { t: translation } = useTranslation();
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const signOut = useSignOut();

  const go = (to: string) => () => {
    setAnchorElUser(null);
    navigate(to);
  };

  return (
    <Stack direction="row" alignItems="center">
      <Box sx={{ flexGrow: 0 }}>
        <IconButton
          onClick={event => {
            setAnchorElUser(event.currentTarget);
          }}
          disableRipple
          sx={{
            p: 0,
            img: { borderRadius: theme => theme.radius.full, position: 'static !important' }
          }}
        >
          {identity.avatar != null ? (
            <Img
              src={identity.avatar.id}
              fit="cover"
              thumbhash={identity.avatar.hash}
              alt="image"
              width={40}
              height={40}
            />
          ) : (
            <UserAvatar size="s" name={identity.fullName} />
          )}
        </IconButton>

        <StyledMenu anchorEl={anchorElUser} setAnchorEl={setAnchorElUser}>
          <Stack
            sx={{
              padding: theme => theme.spacing(3, 5),
              backgroundColor: theme => theme.brandPalette.background.neutral
            }}
          >
            <Typography
              variant="labelSmall"
              sx={{ color: theme => theme.brandPalette.foreground.neutral }}
            >
              {translation('components.accountMenu.signedInAs')}
            </Typography>
            <Typography
              variant="labelSmall"
              sx={{ color: theme => theme.brandPalette.foreground.neutral, fontWeight: 500 }}
            >
              {identity.email}
            </Typography>
          </Stack>
          <Divider />
          <MenuItem onClick={go(`/administrators/${identity.id}/overview`)} text="My overview" />
          <MenuItem onClick={go('/settings/security/password')} text="Sign-in & security" />
          <Divider />
          <MenuItem
            onClick={() => {
              setAnchorElUser(null);
              return signOut();
            }}
            text={translation('components.accountMenu.logout')}
          />
        </StyledMenu>
      </Box>
    </Stack>
  );
}
